import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m3.308 8.625.75.749a.58.58 0 1 1-.82.82L1.5 8.456a.58.58 0 0 1 0-.82l1.739-1.74a.58.58 0 0 1 .82.821l-.75.749h4.107V3.308l-.751.751a.58.58 0 1 1-.82-.818l1.74-1.74a.58.58 0 0 1 .82 0l1.738 1.739a.58.58 0 0 1-.82.818l-.748-.747v4.155h4.105l-.748-.749a.58.58 0 0 1 .82-.82l1.738 1.738a.58.58 0 0 1 0 .82l-1.739 1.74a.58.58 0 0 1-.82-.821l.75-.75H8.574v4.156l.749-.747a.58.58 0 1 1 .82.819l-1.74 1.739a.58.58 0 0 1-.82 0l-1.738-1.739a.58.58 0 0 1 .82-.82l.75.75V8.625z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })